export default {
    "de": {
        "jobs": {
            "common": {
                "title": {
                    "technician_message_fittings": "Meldung Beschläge",
                    "technician_repair_request": "Reparaturauftrag angefordert",
                    "technician_message_common": "Allgemeine Meldung",
                    "technician_message_checks": "Neue Notiz"
                },
                "text": {
                    "technician_message_checks": "{actionLinks.showJobNotification} von Monteur {trigger.link} beim Abarbeiten der Checklisten einer Tür.",
                    "technician_repair_request": "Monteur {trigger.link} hat einen Reparaturauftrag angefordert.",
                    "technician_message_fittings": "{actionLinks.showJobNotification} von Monteur {trigger.link} beim Überprüfen der Beschläge.",
                    "technician_message_common": "Neue allgemeine {actionLinks.showJobNotification} von Monteur {trigger.link}."
                },
                "data": {
                    "titles": {
                        "projectNr": "Zum Projekt",
                        "address": "Zum Projekt"
                    },
                    "labels": {
                        "projectNr": "Projekt #"
                    }
                },
                "actions": {
                    "showJobNotification": "Neue Notiz",
                    "jobMessage": "Meldung"
                }
            },
            "assembling": {
                "title": {
                    "technician_request_send": "Neue Montageanfrage",
                    "technician_request_respond": "Montageanfrage beantwortet",
                    "technician_request_revoke": "Montageanfrage zurückgezogen",
                    "technician_request_cancel": "Montagetermin storniert",
                    "job_close_cancelled": "Montage abgebrochen",
                    "job_close_unfinished": "Montage unvollständig abgeschlossen",
                    "job_close_finished": "Montage abgeschlossen",
                    "job_close_without_text": "Montage abgeschlossen",
                },
                "text": {
                    "job_close_cancelled": "Monteur {trigger.link} hat die Montage abgebrochen.",
                    "job_close_unfinished": "Monteur {trigger.link} hat die Montage unvollständig abgeschlossen.",
                    "job_close_finished": "Monteur {trigger.link} hat die Montage abgeschlossen."
                },
                "actions": {
                    "showJobInList": "Zur Montage"
                },
                "type_actions": []
            },
            "servicing": {
                "title": {
                    "technician_request_send": "Neue Serviceanfrage",
                    "technician_request_respond": "Serviceanfrage beantwortet",
                    "technician_request_revoke": "Serviceanfrage zurückgezogen",
                    "technician_request_cancel": "Servicetermin storniert",
                    "job_close_cancelled": "Serviceauftrag abgebrochen",
                    "job_close_unfinished": "Serviceauftrag unvollständig abgeschlossen",
                    "job_close_finished": "Serviceauftrag abgeschlossen"
                },
                "text": {
                    "job_close_cancelled": "Monteur {trigger.link} hat den Serviceauftrag abgebrochen.",
                    "job_close_unfinished": "Monteur {trigger.link} hat den Serviceauftrag unvollständig abgeschlossen.",
                    "job_close_finished": "Monteur {trigger.link} hat den Serviceauftrag abgeschlossen."
                },
                "actions": {
                    "showJobInList": "Zum Service"
                },
                "type_actions": []
            }
        }
    }
}
